module.exports = __webpack_public_path__ + "img/virtual_tokenstokens.2a9ed02.png";